<template>
  <div class="BillingRecords">
    <div class="tips"><i class="el-icon-warning"></i> 账单仅保留12天，如需要请自行保存！</div>
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
      >
        <el-select
          clearable
          v-model="apiAppKey"
          placeholder="选择Appkey"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.name"
            :value="item.app_key"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="time"
          style="margin:0 10px;"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectTime"
        >
        </el-date-picker>
        <el-button
          id="clearBtn"
          @click="clear"
        >重置</el-button>
        <el-button
          id="searchBtn"
          @click="getbillInfo"
          type="primary"
        >查询</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :default-sort="{prop: 'date', order: 'descending'}"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="bill_time"
            label="账期"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="app_key"
            label="Appkey"
          >
          </el-table-column>
          <el-table-column
            prop="count"
            sortable
            label="调用次数"
          >
          </el-table-column>
          <el-table-column
            prop="cope_with"
            sortable
            label="应付/元"
          >
          </el-table-column>
          <el-table-column
            prop="preferential"
            sortable
            label="优惠/元"
          >
          </el-table-column>
          <el-table-column
            prop="real_buckle"
            sortable
            label="实际扣款/元"
          >
          </el-table-column>
          <el-table-column
            prop="discount"
            sortable
            label="套餐抵扣/元"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="生成时间"
          >
          </el-table-column>
        </el-table>
        <div class="pager">
          <el-pagination
            background
            :page-size="pagesize"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="totalcount"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import apis from "@/api/apis";
export default {
  name: 'BillingRecords',

  data () {
    return {
      value1: '',
      apiAppKey: '',
      date: '',
      pagesize: 10,
      pagenum: 1,
      totalcount: 0,
      time: '',
      startTime: '',
      endTime: '',
      tableData: [],
      options: []
    };
  },

  mounted () {
    this.getbillInfo()
  },
  methods: {
    handleCurrentChange (val) {
      this.pagenum = val
      this.getbillInfo()
    },
    getAppDetail () {
      apis.app.index({
        page: 1,
        page_size: 100,
      }).then(res => {
        this.options = res.data.list

      })
    },
    getbillInfo () {
      apis.index.billInfo({
        start_time: this.startTime,
        end_time: this.endTime,
        app_key: this.apiAppKey,
        page: this.pagenum,
        page_size: this.pagesize
      }).then(res => {
        this.tableData = res.data.list
        this.totalcount = parseInt(res.data.count)
        this.getAppDetail()
      })
      document.getElementById("searchBtn").blur()
    },
    clear () {
      this.startTime = []
      this.apiAppKey = []
      this.endTime = []
      this.time = []
      this.getbillInfo()
      document.getElementById("clearBtn").blur()
    },
    //选择时间
    selectTime () {
      console.log(this.value, "app_key");
      this.startTime = this.filterTime(this.time[0])
      this.endTime = this.filterTime(this.time[1])
    },
    //中国标准时间转换格式
    filterTime (time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    tableHeaderColor ({ rowIndex, }) {
      if (rowIndex === 0) {
        return 'background-color: #FAFAFA;color: #000;font-weight: 500;'
      }
    }

  }
}
</script>
<style lang="scss" scoped>
.tips {
  padding-left: 17px;
  line-height: 40px;
  height: 40px;
  background: #fffbe6;
  border-radius: 2px;
  border: 1px solid #ffe58f;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;

  color: rgba(0, 0, 0, 0.65);
  i {
    font-size: 16px;
    color: #faad14;
  }
}
.box-card {
  margin-top: 15px;
  padding: 10px;
  background: #ffffff;
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }
  .clearfix:after {
    clear: both;
  }
  .pager {
    margin-top: 10px;
    width: 100%;
    height: 64px;
    background: #ffffff;
    padding-right: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>